export function getCookieValue(name: string): string | null {
  let cookies = document.cookie.split("; ");
  let value = cookies.find((cookie) => cookie.startsWith(name + "="));
  return value ? decodeURIComponent(value.split("=")[1]) : null;
}

export function setCookie(key: string, value: string, days: number) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${key}=${value};${expires};path=/`;
}
